import {useCallback, useState} from 'react';

export function createInputState() {
    const [state, setInputState] = useState<string>('');

    const hasInput = useCallback((): boolean => state !== '', [state]);

    const getInput = useCallback((): string => state, [state]);

    const setInput = (value: string): void => setInputState(value);

    const clearInput = useCallback( (): void => setInputState(''), []);

    return {
        state,
        hasInput,
        getInput,
        setInput,
        clearInput,
    };
}
